import { getTld } from "@/utils/urlHelper.ts";
import { COMPANY_COMBINATOR, COMPANY_EEI, COMPANY_EFC } from "@/utils/variables";
import featureService from "@/api/services/featureService";
import { defineStore } from "pinia";
import { useUserStore } from "@/store/user";
import { useVisitStore } from "@/store/visit";

interface CompanyState {
  busy: boolean;
  company: string | null;
}

export const useCompanyStore = defineStore("company", {
  state: (): CompanyState => ({
    busy: false,
    company: null,
  }),

  getters: {
    getCompany: (state: CompanyState) => state.company,
    isBusy: (state: CompanyState) => state.busy,
    isEEI: (state: CompanyState) => state.company === COMPANY_EEI,
    isCombinator: (state: CompanyState) => state.company === COMPANY_COMBINATOR,
    isEFC: (state: CompanyState) => state.company === COMPANY_EFC,
  },

  actions: {
    async defineCompany(apiCheck = true) {
      if (this.busy) {
        return;
      }

      let company;

      const tld = getTld();

      if (tld === "net") {
        company = COMPANY_EEI;
      } else if (tld === "de") {
        company = COMPANY_EFC;
      } else if (tld === "ch") {
        company = COMPANY_COMBINATOR;
      } else {
        if (apiCheck && this.busy) {
          return;
        }

        const user = useUserStore().getProfile;
        const visit = useVisitStore().getVisit;

        if (user) {
          company = user.company;
        } else if (visit?.features?.eei || visit?.features?.combinator) {
          company =
            visit?.features?.combinator?.is_active || !visit?.features?.eei
              ? visit?.features?.combinator?.version
              : visit?.features?.eei?.version;
        } else {
          try {
            if (apiCheck) {
              this.busy = true;
            }

            company = apiCheck ? await featureService.getCompany() : COMPANY_EFC;
          } catch {
            company = COMPANY_EFC;
          }
        }
      }

      if (apiCheck) {
        this.busy = false;
      }

      this.company = company;
    },
  },
});
